/**
 * 将打包页面发往本地 `/api/*` 的请求转换为正式 HTTPS 后端地址。
 * 其他静态资源和外部请求保持不变。
 */
export function rewriteApiUrl(rawUrl, appUrl, apiBaseUrl) {
  const parsed = new URL(rawUrl, appUrl);
  const app = new URL(appUrl);
  // Custom schemes such as capacitor: have the opaque origin "null".
  // Compare their actual authority so another custom scheme is not mistaken for this app.
  const belongsToPackagedApp = parsed.protocol === app.protocol && parsed.host === app.host;

  if (!belongsToPackagedApp || !parsed.pathname.startsWith("/api/")) {
    return rawUrl;
  }

  return `${apiBaseUrl.replace(/\/$/, "")}${parsed.pathname}${parsed.search}${parsed.hash}`;
}
